import { apiPost } from "./api";

export default class ServicioHistorialClinico {
	static crear(pacienteId) {
		const data = { PacienteID: pacienteId };
		return apiPost("/historiaclinica/Crear", data);
	}
	static getDatosHistorial(historiaClinicaId) {
		const datos = { HistoriaClinicaID: historiaClinicaId };
		return apiPost("/historiaclinica/ObtenerInfo", datos);
	}
	static guardarAntecedentesHeredofamiliares(datos) {
		return apiPost("/historiaclinica/Antecedentes_Heredofamiliares", datos);
	}
	static guardarAntecedentesNoPatologicos(datos) {
		return apiPost("/historiaclinica/Antecedentes_NoPatologicos", datos);
	}
	static guardarAntecedentesPatologicos(historiaClinicaId, datos) {
		const payload = {
			HistoriaClinicaID: historiaClinicaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/historiaclinica/Antecedentes_Patologicos", payload);
	}
	static guardarTerapiaRenal(historiaClinicaId, datos) {
		const payload = {
			HistoriaClinicaID: historiaClinicaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/historiaclinica/Terapia_Renal", payload);
	}
	static guardarEvaluacionAntropometrica(historiaClinicaId, datos) {
		const payload = {
			HistoriaClinicaID: historiaClinicaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/historiaclinica/Evaluacion_Antropometrica", payload);
	}
	static guardarResultadosBioimpedancia(historiaClinicaId, datos) {
		const payload = {
			HistoriaClinicaID: historiaClinicaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/historiaclinica/Resultados_Bioimpedancia", payload);
	}
	static guardarEvaluacionBioquimica(historiaClinicaId, datos) {
		const payload = {
			HistoriaClinicaID: historiaClinicaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/historiaclinica/Evaluacion_Bioquimica", payload);
	}
	static guardarExploracionFisica(historiaClinicaId, datos) {
		const payload = {
			HistoriaClinicaID: historiaClinicaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/historiaclinica/Exploracion_Fisica", payload);
	}
	static guardarValoracionGlobal(historiaClinicaId, datos) {
		const payload = {
			HistoriaClinicaID: historiaClinicaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/historiaclinica/Valoracion_Global", payload);
	}
	static guardarEvaluacionDietetica(historiaClinicaId, datos) {
		const payload = {
			HistoriaClinicaID: historiaClinicaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/historiaclinica/Evaluacion_Dietetica", payload);
	}
	static guardarRecordatorios(historiaClinicaId, datos) {
		const payload = {
			HistoriaClinicaID: historiaClinicaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/historiaclinica/Recordatorio_Horas", payload);
	}
	static guardarDiagnosticoNutricional(historiaClinicaId, datos) {
		const payload = {
			HistoriaClinicaID: historiaClinicaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/historiaclinica/Diagnostico_Nutricional", payload);
	}
	static guardarPlanTerapeutico(historiaClinicaId, datos) {
		const payload = {
			HistoriaClinicaID: historiaClinicaId,
			json: JSON.stringify(datos)
		};
		return apiPost("/historiaclinica/Plan_Terapeutico", payload);
	}
}
